module.exports = __webpack_public_path__ + "static/media/extreme.e146492.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/extreme.mp3
// module id = FwCL
// module chunks = 82